<template>
	<div class="header">
		<!-- top -->
		<div class="psi-header">
			<!-- <span>诊所管理</span> -->
			<!-- 诊所描述Card v-for="(v,i) in psi" :key="v" -->
			<div class="inCard">
				<li v-for="(v,i) in psi" :key="i" @click="chooseTabs(v,i)">
					<i :class="v.icon" style="font-size: 28px;"></i>
					<span style="font-size: 10px;margin-top: 2px;">{{ v.title }}</span>		
				</li>
			</div>
		</div>
		<!-- content -->
		<div class="content">
			
		</div>
	</div>
</template>

<script>
	// selfs / js
	import psi from '../../external/PSI.js'
	export default {
		components: {
			psi
		},
		data() {
			return {
				// 监听bus存放的Breads数据
				//arr
				psi:[],
				//blean
				disabled:false,
				contIndex:0,
			}
		},
		//侦听器
		watch: {
		
		},
		created() {
			
		},
		mounted() {
			// 模拟信息
			this.psi = psi.map(function(v) {
				return v
			})
		},
		methods: {
			chooseTabs(v,i){
				// console.log(v.path);
				// if(i == 0){
				// 	// 如果你使用的是Vue Router，可以通过重新导航到当前路由来刷新页面
				// 	    this.$router.go(0)
				// }else{
				// }
					//  路径/对应在router目录下index.js中定义的path属性值
					this.$router.push(v.path);
			}
		},

	}
</script>

<style lang="less" scoped>
	.header {
		padding: 0 12px;
		display: flex;
		flex-direction: column;
		.psi-header{
			width: 100%;
			height: 80px;
			.inCard{
				display: flex;
				li{
					display: flex;
					flex-direction: column;
					margin: 8px;
					align-items: center;
					background-color: #d9d9d9;
					border-radius: 10px;
					padding: 12px;
				}
				li:hover{
					cursor: pointer;
					background-color: #3c96f0;
					opacity: .6;
					// border: 1px solid #409EFF;
					color: #fff;
				}
			
			}
		}
	}
</style>